"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CullingManager = void 0;
const constants_1 = __importDefault(require("../shared/constants"));
const create_1 = require("./create");
const phaser_1 = __importDefault(require("phaser"));
class CullingManager {
    constructor(gridLength) {
        this.spriteGrid = [];
        this.gridLength = gridLength;
        for (let x = 0; x < Math.ceil(constants_1.default.MAP_SIZE_X / this.gridLength); x++) {
            this.spriteGrid[x] = [];
            for (let y = 0; y < Math.ceil(constants_1.default.MAP_SIZE_Y / this.gridLength); y++) {
                this.spriteGrid[x][y] = [];
            }
        }
        this.cullingData = {
            xPos: null,
            yPos: null,
            currentGrids: null
        };
    }
    addEntity(entity) {
        let gridXPos = Math.floor(entity.x / this.gridLength);
        let gridYPos = Math.floor(entity.y / this.gridLength);
        this.spriteGrid[gridXPos][gridYPos].push(entity);
    }
    removeAllEntities() {
        for (let x = 0; x < Math.ceil(constants_1.default.MAP_SIZE_X / this.gridLength); x++) {
            this.spriteGrid[x].length = 0;
            for (let y = 0; y < Math.ceil(constants_1.default.MAP_SIZE_Y / this.gridLength); y++) {
                this.spriteGrid[x][y] = [];
            }
        }
        this.cullingData = {
            xPos: null,
            yPos: null,
            currentGrids: null
        };
    }
    update() {
        let currentXPos = Math.floor(create_1.player.x / this.gridLength);
        let currentYPos = Math.floor(create_1.player.y / this.gridLength);
        if ((this.cullingData.xPos == null || this.cullingData.xPos != currentXPos) || (this.cullingData.yPos == null || this.cullingData.yPos != currentYPos)) {
            let newCoords = this.getNewCoords(currentXPos, currentYPos);
            // check if any grid no longer present
            if (this.cullingData.currentGrids) {
                this.cullingData.currentGrids.forEach(gridCoords => {
                    let gridExists;
                    newCoords.forEach(newCoords => {
                        if (newCoords.x == gridCoords.x && newCoords.y == gridCoords.y) {
                            gridExists = true;
                        }
                    });
                    if (!gridExists) {
                        if (this.spriteGrid[gridCoords.x] && this.spriteGrid[gridCoords.x][gridCoords.y]) {
                            phaser_1.default.Actions.SetVisible(this.spriteGrid[gridCoords.x][gridCoords.y], false);
                        }
                    }
                });
                // check for new grids
                newCoords.forEach(coords => {
                    let gridExists;
                    this.cullingData.currentGrids.forEach(gridCoords => {
                        if (coords.x == gridCoords.x && coords.y == gridCoords.y) {
                            gridExists = true;
                        }
                    });
                    if (!gridExists) {
                        if (this.spriteGrid[coords.x] && this.spriteGrid[coords.x][coords.y]) {
                            phaser_1.default.Actions.SetVisible(this.spriteGrid[coords.x][coords.y], true);
                        }
                    }
                });
            }
            else {
                newCoords.forEach(coords => {
                    phaser_1.default.Actions.SetVisible(this.spriteGrid[coords.x][coords.y], true);
                });
            }
            this.cullingData.currentGrids = newCoords;
            this.cullingData.xPos = currentXPos;
            this.cullingData.yPos = currentYPos;
        }
    }
    getNewCoords(currentXPos, currentYPos) {
        return [
            { x: currentXPos - 1, y: currentYPos - 1 },
            { x: currentXPos, y: currentYPos - 1 },
            { x: currentXPos + 1, y: currentYPos - 1 },
            { x: currentXPos - 1, y: currentYPos },
            { x: currentXPos, y: currentYPos },
            { x: currentXPos + 1, y: currentYPos },
            { x: currentXPos - 1, y: currentYPos + 1 },
            { x: currentXPos, y: currentYPos + 1 },
            { x: currentXPos + 1, y: currentYPos + 1 },
        ];
    }
    forceUpdate() {
        let currentXPos = Math.floor(create_1.player.x / this.gridLength);
        let currentYPos = Math.floor(create_1.player.y / this.gridLength);
        if (this.cullingData.currentGrids) {
            this.cullingData.currentGrids.forEach(gridCoords => {
                if (this.spriteGrid[gridCoords.x] && this.spriteGrid[gridCoords.x][gridCoords.y]) {
                    phaser_1.default.Actions.SetVisible(this.spriteGrid[gridCoords.x][gridCoords.y], false);
                }
            });
        }
        let newCoords = this.getNewCoords(currentXPos, currentYPos);
        newCoords.forEach(coords => {
            phaser_1.default.Actions.SetVisible(this.spriteGrid[coords.x][coords.y], true);
        });
        this.cullingData.currentGrids = newCoords;
        this.cullingData.xPos = currentXPos;
        this.cullingData.yPos = currentYPos;
    }
}
exports.CullingManager = CullingManager;
